import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { DifferenceSection } from './components/DifferenceSection';
import { ServicesSection } from './components/ServicesSection';
import { GallerySection } from './components/GallerySection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { CTASection } from './components/CTASection';
import { FAQSection } from './components/FAQSection';
import { ServiceAreaSection } from './components/ServiceAreaSection';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-[#f9f7f2] font-sans selection:bg-[#2D5A27] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <DifferenceSection data-id="element-5" />
      <ServicesSection data-id="element-6" />
      <GallerySection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <UrgencySection data-id="element-11" />
      <CTASection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <ServiceAreaSection data-id="element-14" />
      <Footer data-id="element-15" />
      <FloatingCTA data-id="element-16" />
    </div>;
}